import { getCtrlPoint, stringToColor, stringToRGBA, preloadImage1 } from '../../common/common'
import { fillMode, fillStyle, lineShape } from '../../common/enums'
import wbManager from "media/white-board-manager"
let isFirst = false
/**
 * 
 * @param {*} canv 绘画对象
 * @param {*} lineType 0 1 2 3 4
 */
function setLineDash (canv, lineType, ratio) {
  let width1 = 20 * ratio
  let width2 = 5 * ratio
  switch (lineType) {
    case 0: 
      canv.setLineDash([]);
      break;
    case 1: 
      canv.setLineDash([width1, width2]);
      break;
    case 2: 
      canv.setLineDash([width2, width2]);
      break;
    case 3: 
      canv.setLineDash([width1, width2, width2, width2]);
      break;
    case 4:
      canv.setLineDash([width1, width2, width2, width2, width2, width2]);
      break;
    default: 
      canv.setLineDash([]);
  }
}
/**
 * 
 * @param {*} canv 
 * @param {*} obj 
 * @param {*} ratio 
 * @param {*} type 填充类型
 */
function fillCustom (canv, obj, ratio, type) {
  canv.clip() //必须
  canv.beginPath()
  canv.lineCap = "butt"; // 线型
  canv.lineWidth = 1; // 线宽
  canv.setLineDash([]);
  canv.strokeStyle = stringToColor(obj.bg_color); // 线颜色
  let x1 = Math.ceil(obj.left * ratio)
  let y1 = Math.ceil(obj.bottom * ratio)
  let x2 = Math.ceil(obj.right * ratio)
  let y2 = Math.ceil(obj.top * ratio)
  let width = x2 - x1
  let height = y2 - y1
  let space = 8
  let n = Math.ceil(width / space)
  let m = Math.ceil(height / space)
  x2 = x1 + (n + m) * space
  y2 = y1 + (m + n) * space
  switch (type) {
    case fillStyle.SOLID:
      canv.fill();
      break;
    case fillStyle.L_SLASH: 
      for (let i = 1; i <= m + n; i++) {
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x1 + space * i, y1)
        canv.stroke()
        canv.closePath()
        canv.beginPath()
        canv.moveTo(x2, y2 - space * i)
        canv.lineTo(x2 - space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      break;
    case fillStyle.GRID: 
      for (let i = 1; i < n; i++) { // 竖线
        canv.beginPath()
        canv.moveTo(x1 + space * i, y1)
        canv.lineTo(x1 + space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      for (let i = 1; i < m; i++) { // 横线
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x2, y1 + space * i)
        canv.stroke()
        canv.closePath()
      }
      break;
    case fillStyle.IN_GRID: 
      for (let i = 1; i <= m + n; i++) {
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x1 + space * i, y1)
        canv.stroke()
        canv.closePath()
        canv.beginPath()
        canv.moveTo(x2, y2 - space * i)
        canv.lineTo(x2 - space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      for (let i = 1; i <= m + n; i++) {
        canv.beginPath()
        canv.moveTo(x2 - space * i, y1)
        canv.lineTo(x2, y1 + space * i)
        canv.stroke()
        canv.closePath()
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x2 - space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      break;
    case fillStyle.R_SLASH: 
      for (let i = 1; i <= m + n; i++) {
        canv.beginPath()
        canv.moveTo(x2 - space * i, y1)
        canv.lineTo(x2, y1 + space * i)
        canv.stroke()
        canv.closePath()
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x2 - space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      break;
    case fillStyle.VERTICAL:
      for (let i = 1; i < n; i++) { // 竖线
        canv.beginPath()
        canv.moveTo(x1 + space * i, y1)
        canv.lineTo(x1 + space * i, y2)
        canv.stroke()
        canv.closePath()
      }
      break;
    case fillStyle.HORIZONTAL:
      for (let i = 1; i < m; i++) { // 横线
        canv.beginPath()
        canv.moveTo(x1, y1 + space * i)
        canv.lineTo(x2, y1 + space * i)
        canv.stroke()
        canv.closePath()
      }
      break;
    default: 
      canv.fill()
  }
}
/**
 * 
 * @param {*} canv 
 * @param {*} obj  fill_mode 填充模式
 * @param {*} ratio 
 */
function drawFillMode (canv, obj, ratio) {
  if (obj.fill_mode === undefined || obj.fill_mode === fillMode.EMPTY) {
    canv.stroke();
  } else if (obj.fill_mode === fillMode.FILL_WITH_BORDER){
    canv.stroke();
    fillCustom(canv, obj, ratio, obj.bg_shape)
  } else if (obj.fill_mode === fillMode.FILL_NO_BORDER) {
    fillCustom(canv, obj, ratio, obj.bg_shape)
  }
}


const draw = {
  // 直线
  line: (canv, obj, ratio) => {
    canv.beginPath();
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineCap = "butt"; // 线型
    canv.lineWidth = parseInt(obj.brush_size * ratio); // 线宽
    canv.strokeStyle = stringToColor(obj.color); // 线颜色

    canv.moveTo(obj.x1 * ratio, obj.y1 * ratio)
    canv.lineTo(obj.x2 * ratio, obj.y2 * ratio)

    canv.stroke();
    canv.closePath();
  },
  // 曲线
  curve: (canv, obj, ratio) => {
    canv.beginPath();
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineCap = "butt"; // 线型
    canv.lineWidth = obj.brush_size * ratio; // 线宽
    canv.strokeStyle = stringToColor(obj.color); // 线颜色
    const points = obj.points.map((item) => {
      return {
        X: parseInt(item[0] * ratio),
        Y: parseInt(item[1] * ratio)
      }
    })
    if (obj.brush_size > 4) {
      canv.moveTo(points[0].X, points[0].Y);
      for (let i = 1; i < points.length; i++) {
        let ctrlP = getCtrlPoint(points, i - 1)
        canv.bezierCurveTo(ctrlP.pA.x, ctrlP.pA.y, ctrlP.pB.x, ctrlP.pB.y, points[i].X, points[i].Y)
      }
    } else {
      for (let i = 1; i < points.length; i++) {
        canv.lineTo(points[i].X, points[i].Y)
      }
    }
    canv.stroke()
    canv.closePath()
  },
  // 文字
  text: (canv, obj, ratio) => {
    if (!Object.prototype.hasOwnProperty.call(obj, 'charset')) {
      canv.beginPath();
      canv.font = `${obj.fontsize * 4 / 3 * ratio}px "${obj.color}"`;
      canv.textBaseline = "top";
      canv.fillStyle = stringToColor(obj.color);
      var indexLine = 0;
  
        for (var txt of obj.text.split('\r\n')) {
          canv.fillText(txt, obj.left * ratio, (indexLine * 22) + obj.top * ratio);
          indexLine++;
        }
    } else { // 云会议 fix bug #2201
      draw.cloudText(canv, obj, ratio)
    }
    canv.closePath();
  },
 
  cloudText: (canv, obj, ratio) => {
    let fontsize = parseInt((obj.fontsize + '').replace('-', ''))
    canv.font = `${fontsize * ratio}px ${obj.font}`
    canv.fillStyle = stringToColor(obj.color)
    canv.textBaseline = "middle"
    let left = obj.left * ratio
    let bottom = (obj.bottom + fontsize - 10) * ratio
    let maxWidth = (obj.right - obj.left) * ratio
    var strArr = obj.text.split(/\r\n|\n/)
    var row = 0
    for (var i = 0; i < strArr.length; i++) {
      if (strArr[i] == '') {
        row++
      } else {
        var lineBreakNum = drawText(canv, strArr[i], left, bottom,  maxWidth, row, fontsize)
        row = row + lineBreakNum
      }
    }
    function drawText (ctx, str, x1, y1, maxWidth, row, fontsize) {
      str = str.split('')
      let temp = ""     
      let rowTextArr = [] // 存储每一行的文字
      for (var i = 0; i < str.length; i++) {
        // 超过最大宽度自动换行
        if (ctx.measureText(temp + str[i]).width <= maxWidth) {
          temp += str[i]
        } else {
          rowTextArr.push(temp)
          temp = str[i]
        }
      }
      rowTextArr.push(temp)
      for (var j = 0; j < rowTextArr.length; j++) {
        ctx.fillText(rowTextArr[j], x1, y1 + (j + row) * fontsize * ratio)
      }
      return rowTextArr.length
    }
  },
  // 矩形
  rectangle: (canv, obj, ratio) => {
    canv.beginPath();
    setLineDash(canv, obj.line_shape, ratio);

    canv.lineWidth = obj.brush_size * ratio; // 线宽
    canv.strokeStyle = obj.color; // 线颜色
    let x1 = parseInt(obj.x1) * ratio;
    let y1 = parseInt(obj.y1) * ratio;
    let x2 = parseInt(obj.x2) * ratio;
    let y2 = parseInt(obj.y2) * ratio;
    canv.rect(x1, y1, (x2 - x1), (y2 - y1));
    canv.closePath();
    canv.stroke();
  },
  // 荧光笔
  mask_curve: (canv, obj, ratio) => {
    canv.beginPath();
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineCap = "butt"; // 线型
    canv.lineWidth = obj.brush_size * ratio; // 线宽
    canv.strokeStyle = stringToRGBA(stringToColor(obj.color), '.4'); // 线颜色
    const points = obj.points.map((item) => {
      return {
        X: parseInt(item[0] * ratio),
        Y: parseInt(item[1] * ratio)
      }
    })
    if (obj.brush_size > 4) {
      canv.moveTo(points[0].X, points[0].Y);
      for (let i = 1; i < points.length; i++) {
        let ctrlP = getCtrlPoint(points, i - 1)
        canv.bezierCurveTo(ctrlP.pA.x, ctrlP.pA.y, ctrlP.pB.x, ctrlP.pB.y, points[i].X, points[i].Y)
      }
    } else {
      for (let i = 1; i < points.length; i++) {
        canv.lineTo(points[i].X, points[i].Y)
      }
    }
    canv.stroke()
    canv.closePath()
  },
  // 箭头
  arrow: (canv, obj, ratio) => {
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineWidth = obj.brush_size * ratio // 线宽
    canv.strokeStyle = stringToColor(obj.color) // 线颜色
    canv.fillStyle = stringToColor(obj.color)

    drawLineArrow(canv, obj.x1 * ratio, obj.y1 * ratio, obj.x2 * ratio, obj.y2 * ratio, 10, 26)

    /**
     * 画箭头
     * fromX / fromY 起点坐标
     * toX / toY 终点坐标
     * headlen 箭头线的长度
     * theta 箭头线与直线的夹角
     */
    function drawLineArrow (ctx, fromX, fromY, toX, toY, headlen, theta) {
      var arrowX, arrowY // 箭头线终点坐标
      // 计算各角度和对应的箭头终点坐标
      var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI
      var angle1 = (angle + theta) * Math.PI / 180
      var angle2 = (angle - theta) * Math.PI / 180
      var topX = headlen * Math.cos(angle1)
      var topY = headlen * Math.sin(angle1)
      var botX = headlen * Math.cos(angle2)
      var botY = headlen * Math.sin(angle2)

      canv.save()
      ctx.beginPath()

      //画直线
      ctx.moveTo(fromX, fromY)
      ctx.lineTo(toX, toY)
      ctx.stroke()
      ctx.closePath()
      ctx.fill()
      ctx.beginPath()
      // 箭头实线绘画
      canv.setLineDash([])
      arrowX = toX + topX
      arrowY = toY + topY
      //画上边箭头线
      ctx.moveTo(arrowX, arrowY)
      ctx.lineTo(toX, toY)
      arrowX = toX + botX
      arrowY = toY + botY
      //画下边箭头线
      ctx.lineTo(arrowX, arrowY)
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
      ctx.restore()
    }
  },
  rect: (canv, obj, ratio) => {
    canv.save()
    canv.beginPath()
    if (obj.bg_color) {
      canv.fillStyle = stringToColor(obj.bg_color)
    }
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineWidth = obj.brush_size * ratio // 线宽
    canv.strokeStyle = stringToColor(obj.color) // 线颜色

    let x1 = parseInt(obj.left) * ratio
    let y1 = parseInt(obj.bottom) * ratio
    let x2 = parseInt(obj.right) * ratio
    let y2 = parseInt(obj.top) * ratio

    canv.rect(x1, y1, (x2 - x1), (y2 - y1));
    canv.closePath();
    drawFillMode(canv, obj, ratio)
    canv.restore()
  },
  // 圆角矩形
  round_rect: (canv, obj, ratio) => {
    canv.save()
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineWidth = obj.brush_size * ratio // 线宽
    canv.strokeStyle = stringToColor(obj.color) // 线颜色

    let x1 = parseInt(obj.left) * ratio // 矩形左上角 x 轴坐标
    let y1 = parseInt(obj.bottom) * ratio // 矩形左上角 y轴坐标
    let width = parseInt(obj.right - obj.left) * ratio // 矩形的宽度
    let height = parseInt(obj.top - obj.bottom) * ratio // 矩形的高度 
    let radius = Math.min(width, height) / 10 // 圆的半径

    canv.save()
    canv.translate(x1, y1)
    canv.beginPath()
    //从右下角顺时针绘制，弧度从 0 到 1 / 2PI  
    canv.arc(width - radius, height - radius, radius, 0, Math.PI / 2)
    //矩形下边线
    canv.lineTo(radius, height)
    //左下角圆弧，弧度从 1 / 2PI 到 PI
    canv.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)
    //矩形左边线
    canv.lineTo(0, radius)
    //左上角圆弧，弧度从 PI 到 3 / 2PI  
    canv.arc(radius, radius, radius, Math.PI, Math.PI * 3 / 2)
    //上边线
    canv.lineTo(width - radius, 0)
    //右上角圆弧
    canv.arc(width - radius, radius, radius, Math.PI * 3 / 2, Math.PI * 2)
    //右边线  
    canv.lineTo(width, height - radius)
    canv.closePath()
    canv.restore() // 清除translate 改变中线点

    drawFillMode(canv, obj, ratio)
    canv.restore()
    
  },
  // 椭圆
  ellipse: (canv, obj, ratio) => {
    canv.save()
    setLineDash(canv, obj.line_shape, ratio)
    canv.lineWidth = obj.brush_size * ratio // 线宽
    canv.strokeStyle = stringToColor(obj.color) // 线颜色

    let a = parseInt((obj.right - obj.left) / 2) * ratio // 椭圆横半轴长度
    let b = parseInt((obj.top - obj.bottom) / 2) * ratio // 椭圆纵半轴长度
    let x = a + parseInt(obj.left) * ratio // 椭圆中心 x 轴坐标
    let y = b + parseInt(obj.bottom) * ratio // 椭圆中心 y 轴坐标

    let r = (a > b) ? a : b // 选择a、b中的较大者作为arc方法的半径参数
    let ratioX = a / r // 横轴缩放比率
    let ratioY = b / r // 纵轴缩放比率
    canv.save()
    canv.scale(ratioX, ratioY) // 进行缩放（均匀压缩）
    canv.beginPath()
    canv.moveTo((x + a) / ratioX, y / ratioY) //从椭圆的左端点开始逆时针绘制
    canv.arc(x / ratioX, y / ratioY, r, 0, 2 * Math.PI)
    canv.closePath()
    canv.restore() // 清除缩放效果

    drawFillMode(canv, obj, ratio)

    canv.restore()
   
  },
  // 插入图片
  pic: (canv, obj, ratio, onload) => {
    let filePath =  `/${obj.user_data.id}`
    let key2 = `/${obj.user_data.id}/${0}.jpg`
    // sendMessage(key2)
    insertImage(onload)

    function getFileUrl (n) {
      wbManager._getFileUrl(key2).then(() => {
        insertImage(onload, ++n)
      }).catch(() => {
        setTimeout(() => {
          insertImage(onload, ++n)
        }, 500)
      })
    }
    // 图片加载完成
    function insertImage (onload, n = 0) {
      if (n > 10) return
      if (wbManager.cacheFileUrlMap.get(filePath) && wbManager.cacheFileUrlMap.get(filePath).get(key2)) {
        let url = wbManager.cacheFileUrlMap.get(filePath).get(key2)
        preloadImage1(url, (img) => { // 已加载过 直接绘图
          let left = obj.left * ratio
          let bottom = obj.bottom * ratio
          let right = obj.right * ratio
          let top = obj.top * ratio
          canv.drawImage(img, left, bottom, right - left, top - bottom)
          if (!isFirst) { // 解决刷新进入 图片已缓存 路径没有缓存（路径获取异步） 图片图层不一致的问题
            isFirst = true
            onload && onload()
          }
        }, () => { // 加载完成 重现触发全局画图
          onload && onload()
        }, () => { // 加载失败 重现获取地址
          getFileUrl(n)
        })
      } else {
        getFileUrl(n)
      }
    }
  },
  point: (canv, obj, ratio) =>{
    let x = obj.mouse_posx * ratio
    let y = obj.mouse_posy * ratio

    let min = 3 * ratio // 小圆半径
    let max = 15 * ratio // 大圆半径h

    canv.save()
    // 创建径向渐变
    var grd = canv.createRadialGradient(x, y, min ,x, y, max); // 创建径向渐变
    grd.addColorStop(0,"red");
    grd.addColorStop(1,"white");
    canv.fillStyle = grd
    canv.beginPath()
    canv.arc(x, y, max, 0, 2 * Math.PI)
    canv.fill()
    canv.closePath()
    canv.restore()
  }
}
export default draw